import http from "@/utils/http";


export const MessagePushDeptApi = {

    getMessagePushDeptListByCurrentCompany(params) {
        return http.get(`/server/messagePushDept/getMessagePushDeptListByCurrentCompany`,params)
    },
    getMessagePushDeptTree(){
       return http.get(`/server/messagePushDept/getMessagePushDeptTree`)
    },
    addMessagePushDept(data) {
        return http.post(`/server/messagePushDept/addMessagePushDept`,data)
    },
    deleteMessagePushDept(data) {
        return http.post(`/server/messagePushDept/deleteMessagePushDept`,data)
    },
}